/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * Angular 16+ targeting evergreen browsers only needs Zone.js. The legacy
 * core-js / classlist.js / web-animations-js IE shims were removed during the
 * Angular 12→20 upgrade.
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.
